import React from "react"

export function Mail({
  fill = "#FF46AA",
  h = 24,
  w = 24,
  className,
}: {
  fill?: string
  h?: number
  w?: number
  className?: string
}) {
  return (
    <svg width={w} height={h} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="4" width="20" height="16" rx="3" fill="white" />
      <path
        d="M10.91 12.2915L2 6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4 22 5.11929 22 6.5L13.09 12.2915C12.4272 12.7223 11.5728 12.7223 10.91 12.2915Z"
        fill={fill}
      />
    </svg>
  )
}
